import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';


import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { Companyid, DROPDOWN_CONFIG, USER_SUBMENU_ID, TENANT_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class AddTenantsAndOwners extends Component {
    state = {
        roles: [],
        type: 'add',
        Id: null,
        TypeId: '',
        Type: '',
        TypeCode: '',
        Name: '',
        Address: '',
        City: '',
        State: '',
        Country: '',
        ZipCode: '',
        ContactPerson: '',
        Mobile: '',
        Phone: '',
        Fax: '',
        EmailId: '',
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch: false
    }

    // componentDidMount() {
    //     this.getAccess = HASACCESS(USER_SUBMENU_ID);
    //     let id = this.props.match.params.id;
    //     this.props.getMasterTableList('GeUsers?id=' + id);
    //     this.props.getMasterKeywordList('Role');
    //     this.props.getMasterKeywordList('Employee');
    //     this.props.getMasterKeywordList('ApprovalRole');
    //     let type = this.props.match.params.type;

    //     axios.get('/master/api/DropDownValues/FRole')
    //         .then(response => {
    //             if (response.status === 200) {
    //                 let data = []
    //                 if (response.data && response.data.length > 0) {
    //                     data = response.data.map(list => {
    //                         let value = list.id;
    //                         let id = list.id;
    //                         let text = list.text
    //                         return { label: text, value: value.toString(), id: id };
    //                     })
    //                 }
    //                 this.setState({ functionalRoleOptions: data })
    //             }
    //         }
    //         )
    //         .catch(err => {
    //             this.growl.show({ severity: 'error', summary: null, detail: 'Functional Roles Api Failed' });
    //         })

    //     if (type !== 'add') {
    //         this.timer();
    //     }
    // }
    componentDidMount() {
        const id = this.props.match.params.id;
        const type = this.props.match.params.type;

        console.log("ID :", id);
        console.log("TYPE :", type);

        this.setState({ type });

        this.props.getMasterKeywordList("TBS_TYPE");
        this.props.getMasterKeywordList("Country");

        if (type !== "add") {
            this.props.getMasterTableList(
                `res/GetTenantbyid?TenantId=${id}`,
                this.state.CompanyId
            );
        }
    }

    // componentDidMount() {
    //     this.getAccess = HASACCESS(USER_SUBMENU_ID);
    //     let id = this.props.match.params.id;
    //     let type = this.props.match.params.type;
    //     this.setState({ type: type });



    //     if (type !== "add") {
    //         this.props.getMasterTableList(
    //             `res/GetTenantbyid?TypeId=${id}`,
    //             this.state.CompanyId
    //         );
    //     }
    // }

    componentDidUpdate(prevProps) {

        if (this.props.tableLists !== prevProps.tableLists) {
            console.log("API Response:", this.props.tableLists);

            const Tenant = Array.isArray(this.props.tableLists)
                ? this.props.tableLists[0]
                : this.props.tableLists;

            if (!Tenant) return;

            this.setState({
                Id: Tenant.id,
                CompanyId: Tenant.companyid || "",
                TypeId: Tenant.typeId || Tenant.TypeId || "",
                Type: Tenant.type || "",
                TypeCode: Tenant.typeCode || "",
                Name: Tenant.name || "",
                Address: Tenant.address || "",
                City: Tenant.city || "",
                State: Tenant.state || "",
                Country: Tenant.country || "",
                ZipCode: Tenant.zipCode || "",
                ContactPerson: Tenant.contactPerson || "",
                Mobile: Tenant.mobile || "",
                Phone: Tenant.phone || "",
                Fax: Tenant.fax || "",
                EmailId: Tenant.emailId || "",


            });
        }
    }

    // timer = () => {
    //     this.intervalID = setInterval(() => {
    //         this.fetchSingleProcess();
    //     }, 2000)
    // }
    // componentWillUnmount() {
    //     if (this.props.tableLists.usersList !== undefined) {
    //         clearInterval(this.intervalID);
    //     }
    // }

    // fetchSingleProcess = () => {

    //     let id = this.props.match.params.id;
    //     let type = this.props.match.params.type;
    //     let storageItems = [];
    //     if (this.props.tableLists.usersList !== undefined) {
    //         storageItems = this.props.tableLists.users;
    //         clearInterval(this.intervalID);
    //     }
    //     if (storageItems) {
    //         let filterData = storageItems;
    //         if (filterData) {
    //             let roles = '';
    //             let functionalRoles = '';
    //             let approvalroles = '';
    //             if (filterData.roleAssigned != null) {
    //                 roles = filterData.roleAssigned.split(",")
    //             }
    //             if (filterData.functionalRole != null) {
    //                 functionalRoles = filterData.functionalRole.split(",")
    //             }
    //             if (filterData.approvalrole != null) {
    //                 approvalroles = filterData.approvalrole.split(",")
    //             }
    //             var data = {
    //                 type: type,
    //                 Id: filterData.id,
    //                 UserId: filterData.userId,
    //                 EmployeeId: filterData.employeeId,
    //                 RoleId: roles,
    //                 approvalRoleId: approvalroles,
    //                 UserId1: filterData.userid1,
    //                 FirstName: filterData.firstName,
    //                 functionalRoleId: functionalRoles,
    //                 MiddleName: filterData.middleName,
    //                 LastName: filterData.lastName,
    //                 EmailId: filterData.emailId,
    //                 Password: filterData.password,
    //                 MobileNumber: filterData.mobileNumber,
    //                 Activedirectory: filterData.activedirectory,
    //                 Adloginid: filterData.adloginid,
    //                 Disablelogin: filterData.disablelogin,
    //                 IsActive: filterData.isActive,
    //                 CreatedBy: filterData.createdby,
    //                 CreatedDate: filterData.createddate,
    //             }
    //             this.setState(data);

    //         }
    //     }

    // }


    // change = (e) => {
    //     let { name, value } = e.target;
    //     this.setState({ [name]: value, touch: true })

    // }

    change = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            touch: true
        });
    }

    onDropdownChange = (e) => {
        this.setState({
            [e.target.name]: e.value,
            touch: true
        });
    }

    

    add = () => {

        if (this.state.Type === null || this.state.Type === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Type is required' });
            return;
        } else if (this.state.TypeCode === null || this.state.TypeCode.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Code is required' });
            return;
        } else if (this.state.Name === null || this.state.Name.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Name is required' });
            return;
        } else if (this.state.Address === null || this.state.Address.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Address is required' });
            return;
        } else if (this.state.City === null || this.state.City.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'City is required' });
            return;
        } else if (this.state.State === null || this.state.State.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'State is required' });
            return;
        } else if (this.state.Country === null || this.state.Country === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Country is required' });
            return;
        } else if (this.state.ContactPerson === null || this.state.ContactPerson.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Contact Person is required' });
            return;
        } else if (this.state.Mobile === null || this.state.Mobile.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Mobile is required' });
            return;
        } else if (this.state.Phone === null || this.state.Phone.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Phone is required' });
            return;
        } else if (this.state.Fax === null || this.state.Fax.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Fax is required' });
            return;
        } else if (this.state.EmailId === null || this.state.EmailId.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Email ID is required' });
            return;
        }
        var data = {
            // typeId: this.state.TypeId,
            companyid: this.state.CompanyId,
            type: this.state.Type,
            typeCode: this.state.TypeCode,
            name: this.state.Name,
            address: this.state.Address,
            city: this.state.City,
            state: this.state.State,
            country: this.state.Country,
            zipCode: this.state.ZipCode,
            contactPerson: this.state.ContactPerson,
            mobile: this.state.Mobile,
            phone: this.state.Phone,
            fax: this.state.Fax,
            emailId: this.state.EmailId,
        }


        if (this.state.type === 'edit') {
            data.typeId = this.state.TypeId;
        }

        // this.props.processDynamicData('user', this.state.type, data, 'GeUsers');
        this.props.processDynamicData('tenant', this.state.type, data, 'res/GetTenantbyid?' + Companyid);


    }

    resetData = () => {
        var data = {
            // roles: [],
            type: 'add',
            Id: null,
            TypeId: '',
            Type: '',
            TypeCode: '',
            Name: '',
            Address: '',
            City: '',
            State: '',
            Country: '',
            ZipCode: '',
            ContactPerson: '',
            Mobile: '',
            Phone: '',
            Fax: '',
            EmailId: '',
            // CompanyId: this.props.loggedUserDetail.CompanyId,
            touch: false
        }
        this.setState(data);
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/tenant/', this.props);
        }


        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) { this.props.history.push('/dashboard') }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess }

        let roleOptions = [];
        if (this.props.Role && this.props.Role.length > 0) {
            roleOptions = this.props.Role;
        }
        let approvalroleOptions = [];
        if (this.props.ApprovalRole && this.props.ApprovalRole.length > 0) {
            approvalroleOptions = this.props.ApprovalRole;
        }

        let isEnabled = (this.state.touch === true);

        let redirectURL = '/tenant/';
        if (this.props.userDetail && this.props.match.params.id !== undefined) {
            if (this.props.userDetail.userId === this.props.match.params.id) {
                redirectURL = "/dashboard";
            }
        }


        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>Add Tenants & Owner</h1>

                        <div className="p-grid mt1">

                            <div className="p-col-6 p-offset-3">

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Type <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Company" options={this.props.TBS_TYPE} value={String(this.state.Type)} name="Type" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={this.state.type === 'view'} />
                                </div>


                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Code <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="TypeCode" placeholder="Code" value={this.state.TypeCode} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>


                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Name <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="Name" placeholder="Name" value={this.state.Name} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Address <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="Address" placeholder="Address" value={this.state.Address} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">City <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="City" placeholder="City" value={this.state.City} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">State <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="State" placeholder="State" value={this.state.State} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Country <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Select Country" options={this.props.Country} value={this.state.Country} name="Country" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Zip </label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="ZipCode" placeholder="Zip" value={this.state.ZipCode} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Contact Person <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="ContactPerson" placeholder="Contact Person" value={this.state.ContactPerson} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Mobile <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="Mobile" placeholder="Mobile" value={this.state.Mobile} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Phone <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="Phone" placeholder="Phone" value={this.state.Phone} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Fax <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="Fax" placeholder="Fax" value={this.state.Fax} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Email ID <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="EmailId" placeholder="Email ID" value={this.state.EmailId} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>




                                {/* <div className="p-col-12">
                                    <label htmlFor="acSimple">Status :</label>
                                </div>
                                <div className="p-col-12">
                                    <InputSwitch checked={this.state.IsActive} onChange={this.change} name="IsActive" value={this.state.IsActive} />
                                </div> */}
                            </div>
                            <div className="p-col-12 p-lg-12">

                                {/* <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData} to={redirectURL} /> */}

                                <FooterButton
                                    access={accessButton}
                                    disabled={!isEnabled || this.state.type === "view"}
                                    type={this.state.type.toLowerCase()}
                                    save={this.add}
                                    reset={this.resetData}
                                    to="/tenant/"
                                />
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        userPref: state.auth.userPref,
        GetEmployeedropdown: (state.keyword.Employee !== undefined) ? state.keyword.Employee : [],
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        Role: (state.keyword.Role !== undefined) ? state.keyword.Role : [],
        ApprovalRole: (state.keyword.ApprovalRole !== undefined) ? state.keyword.ApprovalRole : [],
        TBS_TYPE: (state.keyword.TBS_TYPE !== undefined) ? state.keyword.TBS_TYPE : [],
        Country: (state.keyword.Country !== undefined) ? state.keyword.Country : [],
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyid) => dispatch(actions.getMasterTableList(table, companyid)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddTenantsAndOwners);